import { useDrawer } from '@cast/design-system';

import { ManifestDrawer, type ManifestDrawerBaseProps } from './ManifestDrawer';

export const useManifestDrawer = () => {
  const { open } = useDrawer();

  return {
    openManifestDrawer: (props: ManifestDrawerBaseProps) => {
      open({ component: ManifestDrawer, props });
    },
  };
};
